import React, { useRef } from "react";
import { Button, Loading } from "../components/UI";
import { Formik, Form as NewForm, Field, useFormikContext } from "formik";
import { string, object, number, array } from "yup";
import * as commondata from "../Common";
import { Link, withRouter } from "react-router-dom";

import {
  Card,
  Col,
  Container,
  Form,
  Tooltip,
  OverlayTrigger,
  Row,
  Form as Bform,
} from "react-bootstrap";
import { useEffect } from "react";
import { useState } from "react";

const TodoHandler = ({
  columnsDefs,
  params,
  loading,
  newformData,
  getHiddenFormFieldValue,
  showAllattribute,
  showHideAttribute,
  isSubmitting,
  formSubmitHandler,
  show,
}) => {
  const [formdata, setFormData] = useState({});
  const focusRef = useRef([]);

  useEffect(() => {
    setFormData(newformData);
  }, [newformData]);
  if (loading) {
    return <Loading />;
  }

  const fields = [];
  let newfilterattr = [];
  newfilterattr = columnsDefs.filter((it) => it.show_on_form === true);
  newfilterattr?.forEach((item) => {
    let validation = {};
    if (item.is_required && item.attribute_type === "tel") {
      const phoneRegExp =
        /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
      validation = {
        required: string()
          .required(commondata.firstUpper(item.headerName + " is required "))
          .matches(phoneRegExp, "Phone number is not valid")
          .max(10, "10 number is allowed"),
      };
    } else if (item.is_required && item.attribute_type === "text") {
      validation = {
        required: string()
          .trim()
          .required(commondata.firstUpper(item.headerName + " is required ")),
      };
    } else if (item.is_required && item.attribute_type === "textarea") {
      validation = {
        required: string()
          .trim()
          .required(commondata.firstUpper(item.headerName + " is required ")),
      };
    } else if (item.is_required && item.attribute_type === "select") {
      validation = {
        required: item.is_multiple
          ? array()
              .min(1)
              .required(
                commondata.firstUpper(item.headerName + " is required ")
              )
          : string().required(
              commondata.firstUpper(item.headerName + " is required ")
            ),
      };
    } else if (item.is_required && item.attribute_type === "priority") {
      validation = {
        required: item.is_multiple
          ? array()
              .min(1)
              .required(
                commondata.firstUpper(item.headerName + " is required ")
              )
          : string().required(
              commondata.firstUpper(item.headerName + " is required ")
            ),
      };
    } else if (item.is_required && item.attribute_type === "checkbox") {
      validation = {
        required: string().required(
          commondata.firstUpper(item.headerName + " is required ")
        ),
      };
    } else if (item.attribute_type === "number") {
      if (item.is_required) {
        validation = {
          required: number()
            .required(commondata.firstUpper(item.headerName + " is required "))
            .min(0),
        };
      } else {
        validation = {
          required: number()
            .min(
              0,
              commondata.firstUpper(
                item.headerName + " must be equal or greater than 0"
              )
            )
            .nullable(true)
            .transform((_, val) => (val ? Number(val) : null)),
        };
      }
    } else if (item.is_required && item.attribute_type === "radio") {
      validation = {
        required: string().required(
          commondata.firstUpper(item.headerName + " is required ")
        ),
      };
    } else if (item.is_required && item.attribute_type === "api") {
      if (item.is_multiple) {
        validation = {
          required: array().required(
            commondata.firstUpper(item.headerName + " is required ")
          ),
        };
      } else {
        validation = {
          required: string().required(
            commondata.firstUpper(item.headerName + " is required ")
          ),
        };
      }
    } else if (item.is_required && item.attribute_type === "assign_to") {
      validation = {
        required: string().required(
          commondata.firstUpper(item.headerName + " is required ")
        ),
      };
    } else if (item.is_required && item.attribute_type === "customer") {
      validation = {
        required: string().required(
          commondata.firstUpper(item.headerName + " is required ")
        ),
      };
    } else if (item.is_required && item.attribute_type === "assign_to") {
      validation = {
        required: string().required(
          commondata.firstUpper(item.headerName + " is required ")
        ),
      };
    } else if (item.is_required && item.attribute_type === "category") {
      validation = {
        required: string().required(
          commondata.firstUpper(item.headerName + " is required ")
        ),
      };
    } else if (item.is_required && item.attribute_type === "status") {
      validation = {
        required: string().required(
          commondata.firstUpper(item.headerName + " is required ")
        ),
      };
    } else if (item.is_required && item.attribute_type === "board") {
      validation = {
        required: string().required(
          commondata.firstUpper(item.headerName + " is required ")
        ),
      };
    } else if (item.attribute_type === "tel") {
      const phoneRegExp =
        /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
      validation = {
        required: string()
          .matches(phoneRegExp, "Phone number is not valid")
          .max(10, "10 number is allowed"),
      };
    } else if (item.attribute_type === "email") {
      validation = {
        required: string().email("Invalid Email"),
      };
    }
    fields.push({
      name: item.field,
      initialValue: newformData[item.field] || "",
      type: item.attribute_type,
      ...validation,
    });
  });

  const initialValues = Object.fromEntries(
    fields.map((fiel) => [fiel.name, fiel.initialValue])
  );
  const validObject = Object.fromEntries(
    fields.map((fiel) => [fiel.name, fiel.required])
  );
  const userSchema = object().shape(validObject);
  //   this.clearFormSelect = new Array(this.state.todoAttr.length).fill(
  //     createRef()
  //   );
  let hiddenAttribute = columnsDefs.filter(
    (it) => it.hidden_form_field == true
  );

  useEffect(() => {
    focusRef.current?.[1]?.focus();
  }, [focusRef, show]);

  return (
    <>
      <Row>
        <Formik
          enableReinitialize
          initialValues={initialValues}
          validationSchema={userSchema}
          onSubmit={(values, { resetForm }) => {
            formSubmitHandler(values, newformData?.pin || false);
          }}
        >
          {(formik) => {
            return (
              columnsDefs.length > 0 && (
                <NewForm>
                  <Row>
                    {columnsDefs?.map((item, index) => {
                      if (
                        !item?.hidden_form_field &&
                        item.show_on_form === true &&
                        item.field !== "pin"
                      ) {
                        return getHiddenFormFieldValue(
                          formik,
                          item,
                          index,
                          focusRef
                        );
                      }
                    })}
                    {hiddenAttribute.length > 0 && (
                      <div
                        className={`${
                          showAllattribute ? "showAllAttr" : ""
                        } hideAttr`}
                      >
                        {hiddenAttribute.map((item, index) => {
                          return getHiddenFormFieldValue(formik, item, index);
                        })}
                      </div>
                    )}

                    {hiddenAttribute.length > 0 && (
                      <Link
                        className="show_more_attribute_detals"
                        onClick={(evt) => {
                          evt.preventDefault();
                          showHideAttribute();
                        }}
                        to={"#"}
                      >
                        {!showAllattribute ? "More Details >>" : "<< Show Less"}
                      </Link>
                    )}
                  </Row>

                  <Button
                    className="muBtn _blue mt-3"
                    text={isSubmitting ? "Saving..." : "Save"}
                    type="submit"
                    disabled={isSubmitting}
                  />
                </NewForm>
              )
            );
          }}
        </Formik>
      </Row>
    </>
  );
};

export default React.memo(TodoHandler);
